import React, { useState, useEffect } from 'react';
import API from '../../services/api';
import { THEME } from '../../constants/theme';

const ETOAgents = () => {
    const [agents, setAgents] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [agentForm, setAgentForm] = useState({ id: null, full_name: '', phone: '', cnic: '', father_name: '', address: '' });

    useEffect(() => {
        fetchAgents();
    }, []);

    const fetchAgents = async () => {
        try {
            const res = await API.get('/v1/eto/agents');
            if (res.data.success) setAgents(res.data.data);
        } catch (err) {
            console.error("Error fetching agents:", err);
        }
    };

    const handleOpenAddModal = () => {
        setAgentForm({ id: null, full_name: '', phone: '', cnic: '', father_name: '', address: '' });
        setIsEditing(false);
        setShowModal(true);
    };

    const handleOpenEditModal = (agent) => {
        setAgentForm(agent);
        setIsEditing(true);
        setShowModal(true);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEditing) {
                await API.put(`/v1/eto/agents/${agentForm.id}`, agentForm);
                alert('Agent updated successfully!');
            } else {
                await API.post('/v1/eto/agents', agentForm);
                alert('Agent added successfully!');
            }
            setShowModal(false);
            fetchAgents();
        } catch (err) {
            alert(err.response?.data?.error || 'Error saving agent');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this agent?")) return;
        try {
            await API.delete(`/v1/eto/agents/${id}`);
            fetchAgents();
        } catch (err) {
            alert('Error deleting agent');
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3 style={{ margin: 0, color: '#1e293b' }}>ETO Agents Management</h3>
                <button
                    onClick={handleOpenAddModal}
                    style={{ padding: '10px 20px', backgroundColor: THEME.secondary || '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 6px rgba(37, 99, 235, 0.2)' }}
                >
                    + Add New Agent
                </button>
            </div>

            {/* Agents Table */}
            <div style={{ backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', color: '#64748b', fontSize: '13px' }}>
                            <th style={{ padding: '15px' }}>Name & Father Name</th>
                            <th style={{ padding: '15px' }}>Phone</th>
                            <th style={{ padding: '15px' }}>CNIC</th>
                            <th style={{ padding: '15px' }}>Address</th>
                            <th style={{ padding: '15px', textAlign: 'center' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {agents.map((agent) => (
                            <tr key={agent.id} style={{ borderBottom: '1px solid #f1f5f9', fontSize: '14px', color: '#334155' }}>
                                <td style={{ padding: '15px', fontWeight: '600' }}>
                                    {agent.full_name} <div style={{ fontSize: '12px', color: '#64748b', fontWeight: 'normal' }}>S/O {agent.father_name || 'N/A'}</div>
                                </td>
                                <td style={{ padding: '15px' }}>{agent.phone || '-'}</td>
                                <td style={{ padding: '15px' }}>{agent.cnic || '-'}</td>
                                <td style={{ padding: '15px' }}>{agent.address || '-'}</td>
                                <td style={{ padding: '15px', textAlign: 'center' }}>
                                    <button onClick={() => handleOpenEditModal(agent)} style={{ marginRight: '8px', padding: '6px 12px', backgroundColor: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Edit</button>
                                    <button onClick={() => handleDelete(agent.id)} style={{ padding: '6px 12px', backgroundColor: '#ef4444', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Delete</button>
                                </td>
                            </tr>
                        ))}
                        {agents.length === 0 && (
                            <tr>
                                <td colSpan="5" style={{ textAlign: 'center', padding: '30px', color: '#94a3b8' }}>No ETO Agents Found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Professional Popup Modal for Add/Edit Agent */}
            {showModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                    <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '16px', width: '450px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)', animation: 'fadeIn 0.3s ease' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h3 style={{ margin: 0, color: '#1e293b' }}>{isEditing ? 'Edit ETO Agent' : 'Add New ETO Agent'}</h3>
                            <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#64748b' }}>✕</button>
                        </div>
                        <form onSubmit={handleFormSubmit}>
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>Full Name *</label>
                                <input
                                    type="text"
                                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', outline: 'none' }}
                                    placeholder="Enter agent full name"
                                    value={agentForm.full_name}
                                    onChange={(e) => setAgentForm({ ...agentForm, full_name: e.target.value })}
                                    required
                                />
                            </div>
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>Father Name</label>
                                <input
                                    type="text"
                                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', outline: 'none' }}
                                    placeholder="Enter father name"
                                    value={agentForm.father_name}
                                    onChange={(e) => setAgentForm({ ...agentForm, father_name: e.target.value })}
                                />
                            </div>
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>Phone Number</label>
                                <input
                                    type="text"
                                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', outline: 'none' }}
                                    placeholder="03XXXXXXXXX"
                                    value={agentForm.phone}
                                    onChange={(e) => setAgentForm({ ...agentForm, phone: e.target.value })}
                                />
                            </div>
                            <div style={{ marginBottom: '15px' }}>
                                <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>CNIC</label>
                                <input
                                    type="text"
                                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', outline: 'none' }}
                                    placeholder="XXXXX-XXXXXXX-X"
                                    value={agentForm.cnic}
                                    onChange={(e) => setAgentForm({ ...agentForm, cnic: e.target.value })}
                                />
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>Address</label>
                                <input
                                    type="text"
                                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', outline: 'none' }}
                                    placeholder="Enter complete address"
                                    value={agentForm.address}
                                    onChange={(e) => setAgentForm({ ...agentForm, address: e.target.value })}
                                />
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <button type="button" onClick={() => setShowModal(false)} style={{ padding: '10px 16px', border: '1px solid #cbd5e1', borderRadius: '8px', background: 'none', cursor: 'pointer', fontWeight: '600', color: '#64748b' }}>Cancel</button>
                                <button type="submit" style={{ padding: '10px 20px', backgroundColor: THEME.secondary || '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600' }}>
                                    {isEditing ? 'Update Agent' : 'Save Agent'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ETOAgents;